import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";

import { DropdownsSettingsContent } from "./components/content/DropdownsSettingsContent";

export const DropdownsSettings = withAuthorization(DropdownsSettingsContent, UserPermission.Supervisor);
